// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"183":"45cb0373","240":"45cb0373","1127":"64be0b09","1293":"45cb0373","1902":"0221292d","3040":"d059637d","3524":"9c7eedc6","5417":"d34918d0","6632":"7765bbc0","7749":"45cb0373"}[chunkId] + ".chunk.css";
};